import { useEffect, useState } from 'react';
import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { PageView } from '../../../models/analytics';
import { useAppSelector } from '../../../stores/redux-store';
import { Credentials } from '../../../models/credentials';

export const useAnalyticsCredentialsUpdating = () => {
  const { tinklinkAnalytics } = useAnalytics();
  const credentials = useAppSelector((state) => state.credentials.data);
  const [isLoadingEventSent, setIsLoadingEventSent] = useState(false);

  useEffect(() => {
    // Here auth is successful and BE is fetching/processing transactions data.
    const isCredentialsUpdating = Credentials.isUpdating(credentials);

    if (isCredentialsUpdating && !isLoadingEventSent) {
      tinklinkAnalytics.sendViewEvent({
        view: PageView.CREDENTIALS_UPDATING_LOADING_SCREEN,
      });
      setIsLoadingEventSent(true);
    }
  }, [credentials, setIsLoadingEventSent, isLoadingEventSent, tinklinkAnalytics]);
};
